import { render, staticRenderFns } from "./pointsExchangeOrder.vue?vue&type=template&id=bc066a64&scoped=true"
import script from "./pointsExchangeOrder.vue?vue&type=script&lang=js"
export * from "./pointsExchangeOrder.vue?vue&type=script&lang=js"
import style0 from "./pointsExchangeOrder.vue?vue&type=style&index=0&id=bc066a64&prod&lang=less&scoped=true"
import style1 from "./pointsExchangeOrder.vue?vue&type=style&index=1&id=bc066a64&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc066a64",
  null
  
)

export default component.exports